import { jsx, jsxs } from "react/jsx-runtime";
const IconHome = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 2.09998L1 12H4V21H11V15H13V21H20V12H23L12 2.09998ZM18 19H15V13H9V19H6V10.19L12 4.68998L18 10.19V19Z",
        fill: "currentColor"
      }
    )
  }
);
const IconSidebar = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: Math.round(size * 20 / 24),
    viewBox: "0 0 24 20",
    fill: "none",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M4.07715 0.0996094H19.9229C20.9788 0.0996279 21.9907 0.504276 22.7363 1.22266C23.4818 1.94096 23.9004 2.91453 23.9004 3.92871V16.0713C23.9004 17.0855 23.4818 18.059 22.7363 18.7773C21.9907 19.4957 20.9788 19.9004 19.9229 19.9004H4.07715C3.0212 19.9004 2.00926 19.4957 1.26367 18.7773C0.518186 18.059 0.0996094 17.0855 0.0996094 16.0713V3.92871C0.0996094 2.91453 0.518186 1.94096 1.26367 1.22266C2.00926 0.504276 3.0212 0.0996276 4.07715 0.0996094ZM4.07715 2.04297C3.56031 2.04299 3.06382 2.24056 2.69727 2.59375C2.33057 2.94708 2.12402 3.42736 2.12402 3.92871V16.0713C2.12402 16.5726 2.33057 17.0529 2.69727 17.4062C3.06382 17.7594 3.56031 17.957 4.07715 17.957H6.03027V2.04297H4.07715ZM8.05469 17.957H19.9229C20.4397 17.957 20.9362 17.7594 21.3027 17.4062C21.6694 17.0529 21.876 16.5726 21.876 16.0713V3.92871C21.876 3.42736 21.6694 2.94708 21.3027 2.59375C20.9362 2.24056 20.4397 2.04299 19.9229 2.04297H8.05469V17.957Z",
        fill: "currentColor"
      }
    )
  }
);
const IconCompose = ({ size = 20, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.95216 19.6877C5.99369 19.6794 6.03672 19.6865 6.07357 19.7074C7.55917 20.5512 9.24531 21 11 21C13.4663 21 15.7971 20.1133 17.6265 18.4899C17.7783 18.3552 17.9265 18.2154 18.071 18.071C19.96 16.1824 21 13.6713 21 11C21 8.32909 19.96 5.81806 18.071 3.92901C16.1966 2.05461 13.6654 1.00374 11.0146 1.00001C8.33826 0.996234 5.821 2.03706 3.92905 3.92901C3.78461 4.07349 3.64481 4.22167 3.51012 4.37358C1.88672 6.20337 1 8.53366 1 11C1 12.8347 1.49071 14.5937 2.41 16.1274C2.43403 16.1675 2.44137 16.2153 2.43 16.2606L1.60577 19.5527C1.54751 19.7857 1.61324 20.0322 1.77909 20.206C1.91237 20.3449 2.10817 20.4713 2.45494 20.3876L5.95216 19.6877Z",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M8.44141 11.0098H13.5451", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M11.0039 8.44531V13.549", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
    ]
  }
);
const IconImageUpload = ({ size = 24, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.342 23.9893H8.64729C2.58861 23.9893 0 21.4007 0 15.342V8.64729C0 2.58861 2.58861 0 8.64729 0H15.342C21.4007 0 23.9893 2.58861 23.9893 8.64729V15.342C23.9893 21.4007 21.4007 23.9893 15.342 23.9893ZM8.64729 1.67367C3.50355 1.67367 1.67367 3.50355 1.67367 8.64729V15.342C1.67367 20.4857 3.50355 22.3156 8.64729 22.3156H15.342C20.4857 22.3156 22.3156 20.4857 22.3156 15.342V8.64729C22.3156 3.50355 20.4857 1.67367 15.342 1.67367H8.64729Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.64728 10.5999C6.9513 10.5999 5.57889 9.2275 5.57889 7.53151C5.57889 5.83553 6.9513 4.46312 8.64728 4.46312C10.3433 4.46312 11.7157 5.83553 11.7157 7.53151C11.7157 9.2275 10.3433 10.5999 8.64728 10.5999ZM8.64728 6.13679C7.8774 6.13679 7.25256 6.76162 7.25256 7.53151C7.25256 8.3014 7.8774 8.92624 8.64728 8.92624C9.41717 8.92624 10.042 8.3014 10.042 7.53151C10.042 6.76162 9.41717 6.13679 8.64728 6.13679Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.58414 20.5863C1.31636 20.5863 1.04857 20.4524 0.892361 20.218C0.635731 19.8387 0.736151 19.3143 1.12667 19.0576L6.62747 15.3644C7.83251 14.5499 9.49502 14.6503 10.5885 15.5764L10.9567 15.9C11.5146 16.3798 12.463 16.3798 13.0098 15.9L17.6514 11.9166C18.8341 10.9013 20.6975 10.9013 21.8914 11.9166L23.7101 13.4787C24.056 13.78 24.1006 14.3044 23.7994 14.6615C23.4981 15.0074 22.9737 15.052 22.6166 14.7507L20.7979 13.1886C20.24 12.7088 19.2916 12.7088 18.7337 13.1886L14.0921 17.172C12.9093 18.1873 11.046 18.1873 9.85211 17.172L9.48387 16.8484C8.97061 16.4132 8.12261 16.3686 7.55357 16.7591L2.05277 20.4524C1.90772 20.5416 1.74035 20.5863 1.58414 20.5863Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const IconMicrophone = ({
  size = 17,
  height = 24,
  className,
  style
}) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.5 17.1429C5.68778 17.1429 3.4 14.8359 3.4 12V5.14286C3.4 2.307 5.68778 0 8.5 0C11.3122 0 13.6 2.307 13.6 5.14286V12C13.6 14.8359 11.3122 17.1429 8.5 17.1429ZM8.5 1.71429C6.62533 1.71429 5.1 3.25243 5.1 5.14286V12C5.1 13.8904 6.62533 15.4286 8.5 15.4286C10.3747 15.4286 11.9 13.8904 11.9 12V5.14286C11.9 3.25243 10.3747 1.71429 8.5 1.71429ZM16.15 10.2857C15.6806 10.2857 15.3 10.6695 15.3 11.1429V12C15.3 15.7811 12.2496 18.8571 8.5 18.8571C4.75044 18.8571 1.7 15.7811 1.7 12V11.1429C1.7 10.6695 1.31941 10.2857 0.85 10.2857C0.380587 10.2857 0 10.6695 0 11.1429V12C0 16.4372 3.36069 20.0966 7.65 20.5279V22.2857H5.95C5.48059 22.2857 5.1 22.6695 5.1 23.1429C5.1 23.6162 5.48059 24 5.95 24H11.05C11.5194 24 11.9 23.6162 11.9 23.1429C11.9 22.6695 11.5194 22.2857 11.05 22.2857H9.35V20.5279C13.6393 20.0964 17 16.437 17 12V11.1429C17 10.6695 16.6194 10.2857 16.15 10.2857Z",
        fill: "currentColor"
      }
    )
  }
);
const IconArrowRight = ({ size = 12, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size * 9 / 12,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.1231 4.03711C11.1229 4.03695 11.1228 4.03675 11.1226 4.03659L8.22563 1.16103C8.0086 0.945614 7.65757 0.946414 7.44154 1.1629C7.22553 1.37938 7.22637 1.72952 7.44339 1.94495L9.38841 3.87559H1.55442C1.24822 3.87559 1 4.12315 1 4.42858C1 4.734 1.24822 4.98161 1.55442 4.98161H9.38839L7.44344 6.9122C7.22641 7.12765 7.22557 7.47776 7.44158 7.69423C7.6576 7.91075 8.00867 7.91151 8.22567 7.69612L11.1226 4.82053C11.1228 4.82037 11.1229 4.82017 11.1231 4.82C11.3403 4.60386 11.3396 4.25257 11.1231 4.03712L11.1231 4.03711Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.428571"
      }
    )
  }
);
const IconHamburger = ({ size = 32, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M6 10h12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M6 16h20", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M6 22h16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
    ]
  }
);
const IconChats = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.2796 16.1373L19.118 12.7029C19.6779 11.5401 19.9738 10.2468 19.9758 8.94564C19.9792 6.68311 19.1176 4.54385 17.5495 2.92195C15.9812 1.29973 13.8912 0.386554 11.6647 0.35072C9.35587 0.313654 7.18572 1.20584 5.55419 2.86329C3.98099 4.4615 3.10841 6.56846 3.08079 8.81999C1.53024 10.006 0.615044 11.8551 0.618052 13.8301C0.619497 14.7544 0.824263 15.6731 1.21227 16.5039L0.412153 18.8694C0.274614 19.2761 0.375083 19.7176 0.67438 20.0217C0.885006 20.2357 1.1627 20.3496 1.44829 20.3496C1.56844 20.3496 1.69001 20.3295 1.80856 20.2881L4.13704 19.4752C4.95481 19.8694 5.85915 20.0774 6.76892 20.0789C6.7722 20.0789 6.77532 20.0789 6.77861 20.0789C8.75165 20.0788 10.5856 19.1251 11.7488 17.5112C12.9592 17.4788 14.1569 17.1812 15.2396 16.6431L18.6202 17.8232C18.761 17.8724 18.9055 17.8964 19.0483 17.8964C19.3876 17.8964 19.7176 17.761 19.968 17.5066C20.3236 17.1453 20.443 16.6206 20.2796 16.1373ZM6.77853 18.8695C6.77599 18.8695 6.77329 18.8695 6.77075 18.8695C5.96552 18.8682 5.16587 18.6666 4.45841 18.2863C4.31294 18.2082 4.14216 18.1946 3.98661 18.2489L1.59899 19.0824L2.41942 16.6568C2.47286 16.4988 2.45958 16.3253 2.38262 16.1775C2.00833 15.4588 1.80981 14.6464 1.80856 13.8283C1.80657 12.5124 2.31044 11.2652 3.19157 10.3313C3.47938 12.1137 4.3156 13.7563 5.61177 15.0496C6.89837 16.3335 8.51564 17.1509 10.2606 17.4181C9.33923 18.3407 8.0972 18.8695 6.77853 18.8695ZM19.1261 16.6514C19.0923 16.6858 19.0521 16.6952 19.0069 16.6794L15.3879 15.416C15.325 15.394 15.2596 15.3832 15.1945 15.3832C15.0984 15.3832 15.0027 15.4068 14.9161 15.4534C13.8828 16.0087 12.7151 16.3032 11.5393 16.3051C11.5354 16.3051 11.5319 16.3051 11.528 16.3051C7.58806 16.3051 4.33364 13.0536 4.27122 9.05183C4.23978 7.03646 4.99439 5.14237 6.39599 3.71845C7.79759 2.29454 9.66232 1.52819 11.6458 1.55994C15.5887 1.62348 18.7914 4.93581 18.7853 8.94373C18.7835 10.1383 18.4936 11.3246 17.947 12.3743C17.87 12.522 17.8567 12.6955 17.9102 12.8536L19.1537 16.5303C19.1692 16.5763 19.1599 16.6171 19.1261 16.6514Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.7"
      }
    )
  }
);
const IconChevronUp = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18 15l-6-6-6 6",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
const IconClose = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx("path", { d: "M15.5 4.5L4.5 15.5M4.5 4.5l11 11", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  }
);
const IconSearch = ({ size = 16, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.8178 14.9381L11.913 11.0334C12.8836 9.86621 13.4683 8.36744 13.4683 6.73438C13.4683 3.02103 10.4474 0 6.73421 0C3.02094 0 0 3.02103 0 6.73438C0 10.4475 3.02094 13.4683 6.73421 13.4683C8.36719 13.4683 9.86605 12.8836 11.0332 11.913L14.9381 15.8178C15.0595 15.9393 15.2188 16 15.3779 16C15.5371 16 15.6963 15.9393 15.8179 15.8178C16.0608 15.5748 16.0608 15.181 15.8178 14.9381ZM1.24414 6.73438C1.24414 3.70705 3.70696 1.24414 6.73421 1.24414C9.76137 1.24414 12.2241 3.70705 12.2241 6.73438C12.2241 9.76146 9.76137 12.2241 6.73421 12.2241C3.70696 12.2241 1.24414 9.76146 1.24414 6.73438Z",
        fill: "currentColor"
      }
    )
  }
);
const IconTrash = ({ size = 18, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size * 15.1 / 12.1,
    viewBox: "0 0 12.1 15.1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.44965 4.66556C1.77024 4.67332 2.0238 4.93783 2.01598 5.25636L1.43551 5.24231C0.855035 5.22826 0.855035 5.22826 0.855035 5.22826L0.854262 5.26106L0.85217 5.35429C0.850407 5.43533 0.84797 5.55294 0.845255 5.69963C0.83984 5.99297 0.833345 6.40288 0.82901 6.86938C0.82037 7.79975 0.820235 8.96488 0.855282 9.87965C0.89363 10.8802 0.996852 12.1752 1.08202 13.1395C1.17822 14.2286 2.09883 15.05 3.19023 15.05H8.90975C10.0011 15.05 10.9218 14.2286 11.018 13.1395C11.1031 12.1752 11.2064 10.8802 11.2447 9.87965C11.2797 8.96488 11.2796 7.79975 11.271 6.86938C11.2666 6.40288 11.2602 5.99297 11.2548 5.69963C11.252 5.55294 11.2496 5.43533 11.2478 5.35429L11.2458 5.26106L11.2449 5.22887C11.2371 4.91033 10.9709 4.6578 10.6503 4.66556C10.3297 4.67332 10.0762 4.93783 10.084 5.25636L10.0848 5.28766L10.0868 5.37924C10.0885 5.45915 10.091 5.57549 10.0936 5.7208C10.099 6.01147 10.1055 6.41773 10.1097 6.88003C10.1184 7.80703 10.1182 8.94958 10.0842 9.83578C10.0471 10.8059 9.9461 12.0769 9.86112 13.0387C9.81837 13.5231 9.40805 13.8961 8.90975 13.8961H3.19023C2.69193 13.8961 2.28165 13.5231 2.23887 13.0387C2.15391 12.0769 2.05291 10.8059 2.01573 9.83578C1.98177 8.94958 1.98164 7.80703 1.99025 6.88003C1.99455 6.41773 2.00099 6.01147 2.00635 5.7208C2.00904 5.57549 2.01145 5.45915 2.01319 5.37924L2.01524 5.28766L2.01598 5.25636L1.43551 5.24231Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.05 2.93461C0.05 2.61599 0.309965 2.35769 0.630642 2.35769H11.4693C11.79 2.35769 12.05 2.61599 12.05 2.93461C12.05 3.25324 11.79 3.51154 11.4693 3.51154H0.630642C0.309965 3.51154 0.05 3.25324 0.05 2.93461Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.24241 1.16991C3.61243 0.480583 4.33469 0.05 5.12098 0.05H6.97903C7.76533 0.05 8.48757 0.480583 8.85762 1.16991L9.65907 2.66312C9.81005 2.94426 9.70295 3.29373 9.42005 3.44367C9.13708 3.59361 8.78533 3.48725 8.63443 3.20611L7.8329 1.71289C7.66475 1.39956 7.3364 1.20385 6.97903 1.20385H5.12098C4.7636 1.20385 4.43527 1.39956 4.26708 1.71289L3.46556 3.20611C3.31465 3.48725 2.96293 3.59361 2.67998 3.44367C2.39703 3.29373 2.28998 2.94426 2.4409 2.66312L3.24241 1.16991Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const IconProfile = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 16.2 16.2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.7569 2.44316C12.2458 0.932156 10.2369 0.1 8.1 0.1C5.96313 0.1 3.95416 0.932156 2.44313 2.44316C0.932156 3.95416 0.1 5.96313 0.1 8.1C0.1 10.2369 0.932156 12.2458 2.44313 13.7568C3.95416 15.2678 5.96313 16.1 8.1 16.1C10.2369 16.1 12.2458 15.2678 13.7569 13.7568C15.2678 12.2458 16.1 10.2369 16.1 8.1C16.1 5.96313 15.2678 3.95416 13.7569 2.44316ZM8.1 15.1625C6.19862 15.1625 4.47056 14.407 3.19963 13.1807C3.88788 11.0777 5.86522 9.63125 8.1 9.63125C10.3348 9.63125 12.3121 11.0777 13.0004 13.1807C11.7294 14.407 10.0014 15.1625 8.1 15.1625ZM5.75625 6.35C5.75625 5.05766 6.80766 4.00625 8.1 4.00625C9.39234 4.00625 10.4438 5.05766 10.4438 6.35C10.4438 7.64234 9.39234 8.69375 8.1 8.69375C6.80766 8.69375 5.75625 7.64234 5.75625 6.35ZM13.7044 12.3923C13.0147 10.7787 11.6605 9.55266 10.0238 9.00637C10.8457 8.4095 11.3813 7.44119 11.3813 6.35C11.3813 4.54072 9.90928 3.06875 8.1 3.06875C6.29072 3.06875 4.81875 4.54072 4.81875 6.35C4.81875 7.44119 5.35428 8.4095 6.17619 9.00637C4.5395 9.55266 3.18531 10.7787 2.49563 12.3923C1.58169 11.2018 1.0375 9.71337 1.0375 8.1C1.0375 4.20572 4.20572 1.0375 8.1 1.0375C11.9943 1.0375 15.1625 4.20572 15.1625 8.1C15.1625 9.71337 14.6183 11.2018 13.7044 12.3923Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.2"
      }
    )
  }
);
const IconPurchases = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.4837 6.82721L12.2294 2.06158C12.1581 2.02044 12.0773 1.99878 11.995 1.99878C11.9127 1.99878 11.8319 2.02044 11.7606 2.06158L3.50633 6.82721C3.43507 6.86835 3.3759 6.92752 3.33476 6.99878C3.29362 7.07004 3.27196 7.15087 3.27196 7.23315V16.7644C3.27196 16.8467 3.29362 16.9275 3.33476 16.9988C3.3759 17.07 3.43507 17.1292 3.50633 17.1703L11.7606 21.936C11.8319 21.9771 11.9127 21.9988 11.995 21.9988C12.0773 21.9988 12.1581 21.9771 12.2294 21.936L20.4837 17.1703C20.555 17.1292 20.6141 17.07 20.6553 16.9988C20.6964 16.9275 20.7181 16.8467 20.7181 16.7644V7.23315C20.7181 7.15087 20.6964 7.07004 20.6553 6.99878C20.6141 6.92752 20.555 6.86835 20.4837 6.82721ZM11.995 11.4575L8.80536 9.61596L16.1222 5.39162L19.3118 7.23315L11.995 11.4575ZM11.995 3.00881L15.1847 4.85033L7.86786 9.07471L4.67825 7.23315L11.995 3.00881ZM4.20946 8.04502L7.40087 9.88764V14.2815C7.40087 14.4058 7.45025 14.525 7.53816 14.6129C7.62607 14.7008 7.7453 14.7502 7.86962 14.7502C7.99394 14.7502 8.11317 14.7008 8.20107 14.6129C8.28898 14.525 8.33837 14.4058 8.33837 14.2815V10.4289L11.5263 12.2694V20.7181L4.20946 16.4937V8.04502ZM12.4638 20.7181V12.2694L19.7806 8.04506V16.4937L12.4638 20.7181Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.2"
      }
    )
  }
);
const IconLogout = ({ size = 24, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.4369 8.43779H10.3121C10.0016 8.43779 9.74962 8.1858 9.74962 7.87531C9.74962 7.56482 10.0016 7.31283 10.3121 7.31283H17.4369C17.7474 7.31283 17.9994 7.56482 17.9994 7.87531C17.9994 8.1858 17.7474 8.43779 17.4369 8.43779Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.6245 11.2502C14.4805 11.2502 14.3365 11.1954 14.227 11.0853C14.0072 10.8654 14.0072 10.5092 14.227 10.2895L16.6419 7.87462L14.227 5.45963C14.0072 5.23991 14.0072 4.88369 14.227 4.66397C14.4468 4.44411 14.803 4.44411 15.0228 4.66397L17.8352 7.47638C18.0549 7.6961 18.0549 8.05232 17.8352 8.27204L15.0228 11.0845C14.9125 11.1954 14.7686 11.2502 14.6245 11.2502Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.99983 17.9999C5.83929 17.9999 5.687 17.9774 5.53485 17.9302L1.02139 16.4265C0.407275 16.212 -3.05176e-05 15.6397 -3.05176e-05 15.0001V1.50049C-3.05176e-05 0.673248 0.672724 0.000494242 1.49997 0.000494242C1.66036 0.000494242 1.81266 0.0230155 1.96495 0.0702553L6.47827 1.57396C7.09252 1.78846 7.49969 2.3607 7.49969 3.00035V16.4999C7.49969 17.3272 6.82707 17.9999 5.99983 17.9999ZM1.49997 1.12546C1.29371 1.12546 1.12493 1.29423 1.12493 1.50049V15.0001C1.12493 15.1598 1.23218 15.3082 1.38516 15.3615L5.87747 16.8585C5.90974 16.8689 5.95176 16.875 5.99983 16.875C6.20609 16.875 6.37472 16.7062 6.37472 16.4999V3.00035C6.37472 2.84065 6.26747 2.6922 6.11449 2.63892L1.62219 1.14194C1.58992 1.1315 1.54789 1.12546 1.49997 1.12546Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.4371 6.00035C11.1266 6.00035 10.8746 5.74836 10.8746 5.43787V2.06298C10.8746 1.54622 10.454 1.12546 9.9372 1.12546H1.49996C1.18947 1.12546 0.937481 0.873468 0.937481 0.562977C0.937481 0.252485 1.18947 0.000494242 1.49996 0.000494242H9.9372C11.0749 0.000494242 11.9995 0.92524 11.9995 2.06298V5.43787C11.9995 5.74836 11.7476 6.00035 11.4371 6.00035Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.9372 15.7501H6.9372C6.62671 15.7501 6.37472 15.4981 6.37472 15.1876C6.37472 14.8771 6.62671 14.6251 6.9372 14.6251H9.9372C10.454 14.6251 10.8746 14.2043 10.8746 13.6876V10.3127C10.8746 10.0022 11.1266 9.75021 11.4371 9.75021C11.7476 9.75021 11.9995 10.0022 11.9995 10.3127V13.6876C11.9995 14.8253 11.0749 15.7501 9.9372 15.7501Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  IconArrowRight,
  IconChats,
  IconChevronUp,
  IconClose,
  IconCompose,
  IconHamburger,
  IconHome,
  IconImageUpload,
  IconLogout,
  IconMicrophone,
  IconProfile,
  IconPurchases,
  IconSearch,
  IconSidebar,
  IconTrash
};
//# sourceMappingURL=ConciergeIcons.js.map
